import React from "react";
import HotTermsBlacklist from "pages/Profile/preferences/HotTermsBlacklist";
import styles from "./style.module.scss";

const HotTermsPage = () => (
  <div className={styles.wrapper}>
    <div className={styles.header}>
      <h4 className={styles.title}>Hot Term Blacklist</h4>
      <p className={styles.subtitle}>
        Manage terms that are excluded from hot topic analysis across your organization.
      </p>
    </div>
    <div className={styles.content}>
      <HotTermsBlacklist />
    </div>
  </div>
);

export default HotTermsPage;
